import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { scrollX } from '@finect/tabular-utils/scrollX';
export var ProductItemLine = styled.div.withConfig({
  displayName: "ProductItemLine",
  componentId: "sc-1utjosx-0"
})(["display:flex;position:relative;align-items:center;min-height:36px;font-feature-settings:normal;", ";color:currentColor;", ";"], getFont(0, 'compact'), function (_ref) {
  var nowrap = _ref.nowrap;
  return nowrap && scrollX;
});
export var Graph = styled.div.withConfig({
  displayName: "ProductItemLine__Graph",
  componentId: "sc-1utjosx-1"
})(["flex-shrink:0;width:60px;padding-right:12px;color:", ";"], function (_ref2) {
  var bull = _ref2.bull,
    theme = _ref2.theme;
  return bull ? theme.colors.positive : theme.colors.negative;
});
export var ProductName = styled.strong.withConfig({
  displayName: "ProductItemLine__ProductName",
  componentId: "sc-1utjosx-2"
})(["padding-right:9px;", ";"], function (_ref3) {
  var capitalize = _ref3.capitalize;
  return capitalize && 'text-transform: capitalize;';
});
export var ProductTag = styled.span.withConfig({
  displayName: "ProductItemLine__ProductTag",
  componentId: "sc-1utjosx-3"
})(["padding:4px 6px;border:1px solid ", ";border-radius:", ";margin-right:6px;", ";font-weight:500;color:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    trend = _ref4.trend;
  return !trend ? 'currentColor' : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
}, getFont(-1), function (_ref6) {
  var theme = _ref6.theme,
    trend = _ref6.trend;
  return !trend ? 'currentColor' : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
});
export var Meta = styled.small.withConfig({
  displayName: "ProductItemLine__Meta",
  componentId: "sc-1utjosx-4"
})(["", ";color:", ";&:last-child{padding-right:12px;}span{padding-right:6px;margin-left:6px;}"], getFont(-1), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.fontL;
});